import { Api } from './axios-config';

export interface IProductView {
  id: number;
  businessId: number;
  description: string;
  amount: number;
  profilePicture?: string;
  defaultCommissionPercent?: number;
  isActive: boolean;
}

const getById = async (id: number): Promise<IProductView> => {
  try {
    const { data } = await Api.get<IProductView>(
      `/product/${id}`
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};


const getByIds = async (ids: number[], onlyActive?: boolean): Promise<IProductView[]> => {
  try {
    const params = onlyActive !== undefined ? `?onlyActive=${onlyActive}` : '';
    const { data } = await Api.post<IProductView[]>(
      `/product/ids${params}`, ids
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const getByBusiness = async (businessId: number, onlyActive?: boolean): Promise<IProductView[]> => {
  try {
    const params = onlyActive !== undefined ? `?onlyActive=${onlyActive}` : '';
    const { data } = await Api.get<IProductView[]>(
      `/product/business/${businessId}${params}`
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export interface ICreateProduct {
  businessId: number;
  description: string;
  amount: number;
  defaultCommissionPercent?: number;
  isActive?: boolean;
}

const create = async (body: ICreateProduct): Promise<number> => {
  try {
    const { data } = await Api.post(
      '/product',
      body
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export interface IUpdateProduct {
  id: number;
  businessId: number;
  description: string;
  amount: number;
  defaultCommissionPercent?: number;
  isActive?: boolean;
}

const update = async (body: IUpdateProduct): Promise<IProductView> => {
  try {
    const { data } = await Api.put(
      '/product',
      body
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const remove = async (id: number): Promise<void> => {
  try {
    await Api.delete(
      `/product/${id}`
    );

  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const uploadFile = async (id: number, file: FormData): Promise<string> => {
  try {
    const { data } = await Api.post<string>(
      `/product/${id}/upload`, file
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const deleteFile = async (id: number): Promise<string> => {
  try {
    const { data } = await Api.delete<string>(
      `/product/${id}/profile-picture`
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const productService = {
  getById,
  getByIds,
  getByBusiness,
  create,
  update,
  remove,
  uploadFile,
  deleteFile
};